import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpAdditionalIDPropertiesFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpAdditionalIDProperties
 */

export class ExpAdditionalIDPropertiesFactory {}
_ExpAdditionalIDPropertiesFactory = ExpAdditionalIDPropertiesFactory;
_defineProperty(ExpAdditionalIDPropertiesFactory, "FromJSON", function (json) {
  return _ExpAdditionalIDPropertiesFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpAdditionalIDPropertiesFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'values': json['values']
  };
});
_defineProperty(ExpAdditionalIDPropertiesFactory, "ToJSON", function (value) {
  return _ExpAdditionalIDPropertiesFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpAdditionalIDPropertiesFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'values': value.values
  };
});
//# sourceMappingURL=ExpAdditionalIDProperties.js.map
